<app-invoices-filters
  (searchSubmitted)="getFilters($event); clearSelection()"
  [shippingAddressGroup]="shippingAddressGroup"
  >
</app-invoices-filters>

<div class="mb-4 mt-1 tableContainer customScrollbar">
  @if (invoices && invoices.length) {
    <span
      >{{ (type === 'invoices' ? "SHOWS_INVOICES_FROM" : "SHOW_CREDIT_INVOICES_FROM") | translate }}:
      <strong>{{ formattedDateFrom }}</strong> {{ "TILL" | translate }}
      <strong>{{ formattedDateTo }}</strong></span
      >
    }
    <table class="table">
      <thead>
        <tr>
          <td colspan="3" class="border-0">
            <div class="checkbox" >
              <label>
                <input
                  type="checkbox"
                  (click)="checkAll()"
                  id="checkAll"
                  [(ngModel)]="checkAllState"
                  (change)="checkAll()"
                  [disabled]="pageData?.loading"
                  />
                <span class="box"></span>
                {{ "SELECT_ALL" | translate }}
              </label>
            </div>
          </td>
        </tr>
        @if (invoices && invoices.length) {
          <tr class="financial-item">
            <td style="max-width: 30px; float: left"></td>
            <td>{{ (type === 'invoices' ? "INVOICE_NUMBER" : "CREDIT_INVOICES_NUMBER") | translate }}</td>
            <td>{{ (type === 'invoices' ? "INVOICE_DATE" : "CREDIT_INVOICES_DATE") | translate }}</td>
            @if (applicationService.getSelectCompanyGroupCode() !== 'WG') {
              <td>{{ "DUE_DATE" | translate }}</td>
              <td>{{ "INVOICE_AMOUNT" | translate }}</td>
              <td>{{ "AMOUNT_DUE" | translate }}</td>
              <td>{{ "ORDERNUMBER" | translate }}</td>
              <td>{{ "ORDERNUMBER" | translate }} Accentry</td>
            }
          </tr>
        }
        @if (invoices && !invoices.length && loaded) {
          <tr>
            <td class="border-0">
              <app-no-results></app-no-results>
            </td>
          </tr>
        }
      </thead>
      <tbody>
        @for (invoice of invoices; track invoice; let rowIndex = $index) {
          <app-invoice-line
            class="w-100 d-block d-table-row small financial-item"
            [invoice]="invoice"
            [attr.data-index]="rowIndex + 1 + (pageData.page - 1) * 50"
            (invoiceSelectionChange)="getSelection(); getSelectionForPayment()"
            [onlinePaymentRestrictionLevel]="onlinePaymentRestrictionLevel"
            [disablePayment]="invoice_numbers_for_payment.length > 0"
            [disablePaymentSelection]="invoice_numbers_for_payment.length >= 50"
            [type]="type"
            >
          </app-invoice-line>
        }
      </tbody>
    </table>
    @if (pageData.page < totalPages) {
      <button class="btn btn-dark btn-block" (click)="showMore()">{{"SHOW_MORE"|translate}}</button>
    }
    @if (!loaded) {
      <ngx-skeleton-loader
        count="20"
        appearance="line"
        [theme]="{ height: '80px' }"
        >
      </ngx-skeleton-loader>
    }
  </div>

  @if (invoices && invoices.length) {
    <div class="row">
      <div class="col-md-10">
        <!-- Number of results -->
        <div class="numResults">
          <app-invoice-balance-overview
            [numResults]="pageData.numResults['invoices']"
          ></app-invoice-balance-overview>
        </div>
      </div>
    </div>
  }

  <!-- Paginator -->
  @if (invoices && invoices.length) {
    <app-financial-paginator
      [(pageData)]="pageData"
      (navigation)="navigationChanged($event)"
      >
      <!-- Options -->
      @if (invoice_numbers.length) {
        <i
          class="material-icons  clickable withOpacity mt-1"
          (click)="clearSelection()"
          >
          clear
        </i>
      }
      @if (onlinePaymentRestrictionLevel !== 0 || isHelpdesk) {
        <button [disabled]="!invoice_numbers_for_payment.length || downloading || totalSelectedInvoiceAmountNumber <= 0" (click)="payInvoices()" class="btn btn-dark me-1">
          {{ "PAY_INVOICES" | translate }} @if (invoice_numbers_for_payment.length) {
          ({{invoice_numbers_for_payment.length}} - {{"TOTAL"|translate}} {{totalSelectedInvoiceAmount}})
        }
      </button>
    }
    <button
      class="btn btn-dark d-inline-block "
      (click)="printSelection()"
      [disabled]="!invoice_numbers.length || downloading"
      [ngClass]="{ disabled: downloading }"
      >
      @if (downloading) {
        <span
          class="spinner-border spinner-border-sm me-1"
          role="status"
          aria-hidden="true"
        ></span>
      }
      @if (!downloading) {
        <span>{{ "PDF" | translate }}</span>
      }
      @if (invoice_numbers.length) {
        ({{ invoice_numbers.length }}
        {{
        (invoice_numbers.length ? "INVOICE" : "INVOICES") | translate
        }})
      }
    </button>
  </app-financial-paginator>
}
